import { render, staticRenderFns } from "./icon-pencil.vue?vue&type=template&id=0d6c4641"
import script from "./icon-pencil.vue?vue&type=script&lang=ts"
export * from "./icon-pencil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports